import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueLazyload from 'vue-lazyload';
import saInit from '@/common/sa-init';
import '@/plugins/vant';
import '@/assets/styles/index.less';
import { env, isProd } from '@/config/host';
import probes from '@xl/sec-sign-sdk';
import { AppModule } from '@/store/modules/app';
import performanceReport from '@xl/performance-report';
import sensors from 'sa-sdk-javascript';

const envStr = isProd ? '' : `-${env}`;
const allowList = [
  `driver${envStr}.xiaolachuxing.com`,
  `dic-driver${envStr}.xiaolachuxing.com`,
  `orderhall${envStr}.xiaolachuxing.com`,
  `dpc-driver${envStr}.xiaolachuxing.com`,
  `dcs-driver${envStr}.xiaolachuxing.com`,
  `dappweb${envStr}.xiaolachuxing.com`,
];
// 接口安全签名
probes.init({
  allowList,
});

Vue.config.productionTip = false;

// 初始化store数据
AppModule.InitAppStore(); // app 通用参数初始化
Vue.use(saInit);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require('./assets/img/image-loading@2x.png'),
  attempt: 1,
});

// iOS 跳转其他网页再返回，页面不会刷新，可通过监听 pageShow 变动进行主动刷新
if ('onpagehide' in window) {
  window.addEventListener('pageshow', function() {
    console.log('Show');
    AppModule.SetPageShow(true);
  });
  window.addEventListener('pagehide', function() {
    console.log('Hide');
    AppModule.SetPageShow(false);
  });
}

// 性能上报
performanceReport((params) => {
  sensors.track(`$_join_${params.action.toLowerCase()}`, params);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

